import { GRADES } from 'src/interfaces/grades.types';

export const SECOND_THIRD_THEME_GRADES = [GRADES.SECOND, GRADES.THIRD];
export const K1_THEME_GRADES = [GRADES.K, GRADES.FIRST];

export const FOURTH_FIFTH_THEME_GRADES = [GRADES.FOURTH, GRADES.FIFTH];

export const MIDDLE_SCHOOL_THEME_GRADES = [
  GRADES.SIXTH,
  GRADES.SEVENTH,
  GRADES.EIGHTH,
];
